import { useOfferStore as m } from "../../../store/index.mjs";
import { loadScriptAsync as y } from "../../../utils/load-script.mjs";
import { RAZORPAY_SCRIPT as l } from "../constants/index.mjs";
import { toast as R } from "@systemeio/ui";
import { useState as p, useEffect as u } from "react";
import { useDesignContext as w } from "../../../providers/use-design-provider.mjs";
class z {
  constructor(r) {
    this.options = r, typeof window < "u" && "Razorpay" in window && (this.razorpayInstance = new window.Razorpay(this.options));
  }
  on(r, t) {
    this.razorpayInstance.on(r, t);
  }
  open() {
    this.razorpayInstance.open();
  }
}
function A() {
  const [a, r] = p(!1), [t, s] = p(!1), { currency: e, pricePlan: i, finalAmount: d } = m(), {
    state: { primaryColor: f }
  } = w(), c = function(o) {
    const n = {
      key: o.keyId,
      amount: d,
      currency: e == null ? void 0 : e.toUpperCase(),
      name: o.vendorName,
      description: i == null ? void 0 : i.name,
      prefill: {
        name: o.prefill.name,
        email: o.prefill.email,
        contact: o.prefill.phone
      },
      theme: {
        color: f
      },
      handler: async () => {
        window.location.assign(o.redirectUrl);
      }
    };
    if (o.rpOrderId)
      n.order_id = o.rpOrderId;
    else if (o.rpSubscriptionId)
      n.subscription_id = o.rpSubscriptionId;
    else
      throw Error("RP order id and subscription id is missing");
    return n;
  };
  return u(() => {
    const o = async () => {
      try {
        r(!0), await y(l, document), s(!0);
      } catch (n) {
        R.error(n.message);
      } finally {
        r(!1);
      }
    };
    "Razorpay" in window ? s(!0) : o();
  }, []), { Razorpay: z, generateOptions: c, isRazorpayReady: t, isRazorpayFetching: a };
}
export {
  A as default
};
